import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SpotifyWithCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6S15.302.4 10 .4zm2.964 13.437c-.148 0-.25-.056-.359-.122-1.013-.613-2.268-.935-3.628-.935-.694 0-1.443.082-2.226.242l-.095.024c-.1.024-.201.05-.279.05a.554.554 0 01-.562-.559c0-.318.18-.543.479-.6a11.968 11.968 0 012.687-.316c1.58 0 2.994.365 4.201 1.09.208.121.338.26.338.569a.557.557 0 01-.556.557zm.778-2.183c-.177 0-.292-.067-.395-.127-1.825-1.084-4.547-1.443-6.785-.847a7.61 7.61 0 00-.102.031c-.084.027-.164.053-.274.053a.67.67 0 01-.667-.672c0-.357.186-.607.524-.702a9.95 9.95 0 012.84-.393c1.886 0 3.714.473 5.146 1.33.261.148.379.353.379.658 0 .37-.299.669-.666.669zm.883-2.488a.774.774 0 01-.421-.123c-1.239-.744-3.171-1.186-5.174-1.186-1.043 0-1.99.115-2.817.338a1.295 1.295 0 00-.083.024 1.11 1.11 0 01-.312.058.78.78 0 01-.783-.792c0-.386.217-.681.579-.788.998-.295 2.148-.443 3.415-.443 2.281 0 4.453.506 5.957 1.391.284.16.423.404.423.742a.774.774 0 01-.784.779z"
  }));
});
SpotifyWithCircle.displayName = 'SpotifyWithCircle';
export var SpotifyWithCircleDimensions = {
  height: 20,
  width: 20
};